import { INetwork, IProvider, ISettings } from '@amfi/connect-wallet/src/interface';
import { ContractsNames } from 'services/WalletService/config';
import { AbiItem } from 'web3-utils';

export enum Chains {
  Polygon = 'Polygon',
  // Ethereum = 'Ethereum',
}
export type IChainType = 'testnet' | 'mainnet';

export interface IConnectWallet {
  network: INetwork;
  provider: {
    [index: string]: IProvider;
  };
  settings: ISettings;
}

export type TNativeCurrency = {
  name: string;
  symbol: string; // 2-6 characters long
  decimals: number;
};

export interface IChainConfig {
  name: string;
  id: number;
  rpc: string;
  tx: {
    link: string;
  };
  nativeCurrency: TNativeCurrency;
  blockExp: string;
}

// @see https://docs.metamask.io/guide/rpc-api.html#wallet-addethereumchain
interface AddEthereumChainParameter {
  chainId: string; // A 0x-prefixed hexadecimal string
  chainName: string;
  nativeCurrency: TNativeCurrency;
  rpcUrls: string[];
  blockExplorerUrls?: string[];
  iconUrls?: string[]; // Currently ignored.
}

type TChain = {
  name: string;
  chainId: number;
  nativeCurrency: TNativeCurrency;
  rpc: string;
  blockExplorerUrl: string;
  provider: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
  };
  img?: string;
  network?: AddEthereumChainParameter;
};

export type TChains = Record<
  Chains,
  {
    [chainType in IChainType]: TChain;
  }
>;

export type TokenContractData = {
  address: {
    [chainKey in Chains]: string;
  };
  abi: {
    [chainKey in Chains]: AbiItem[];
  };
};

export interface IContracts {
  decimals: number;
  names: string[];
  contracts: {
    [key in ContractsNames]: {
      [chainType in IChainType]: TokenContractData;
    };
  };
}
